/* src/app/modules/shared/components/header-column/header-column-lineage/header-column-lineage.component.scss */
app-header-column-lineage {
  display: contents;
}
/*# sourceMappingURL=header-column-lineage.component.css.map */
